<script>
import DashboardLayout from "@/Layouts/DashboardLayout.vue";

export default {
    layout: DashboardLayout,
};
</script>

<script setup>
import { computed } from "vue";
import { Head, usePage } from "@inertiajs/vue3";
import FriendsGrid from "@/Components/Profile/FriendsGrid.vue";
import FriendsHero from "@/Components/Friends/FriendsHero.vue";
import FriendsNav from "@/Components/Friends/FriendsNav.vue";

const following = computed(() => usePage().props.following?.data ?? []);
</script>

<template>
    <div>
        <Head>
            <title>Following | Gift Hero</title>
        </Head>

        <FriendsHero
            title="Following"
            subtitle="Friends and experts whose wish lists you follow."
        />

        <div class="md:grid md:grid-cols-[352px_1fr] md:gap-16">
            <!-- Desktop sidebar overlaps the hero band; mobile renders tabs -->
            <div class="md:-mt-[137px]">
                <FriendsNav />
            </div>

            <div class="mt-6 min-w-0 md:mt-[61px]">
                <FriendsGrid
                    :people="following"
                    title="Friends I Follow"
                    empty-message="You aren’t following anyone yet. Find friends and experts to see their lists here."
                />
            </div>
        </div>
    </div>
</template>
